import { AfterViewInit, ChangeDetectorRef, Component, Inject, Optional, TemplateRef, ViewChild } from "@angular/core";
import {
  CtBinaryOperator,
  CtButtonConfiguration,
  CtControlConfiguration,
  CtDatatableContainerService,
  CtModelConfiguration,
  CTModelDatatableFilter, CtModelDatatableOperators, CtModelOnFlyCreateService,
  CtModelRouteData,
  CtModelService,
  CtModelType,
  FormatConfigService,
  MAT_RAISED_PRIMARY,
  MAT_RAISED_WARN,
  MateriaHintExtensionConfig
} from "@ctsolution/ct-framework";
import { ActivatedRoute } from "@angular/router";
import { CTManagerItem } from "../../../_core/classes/ct-manager-item";
import { ItemType } from "../../../_core/enum/item-type";
import { ItemSupplier } from "../../../_core/classes/item-supplier";
import { ItemSupplierRouteData } from "../../../_core/route-data/item-supplier.route-data";
import { ItemRouteData } from "../../../_core/route-data/item.route-data";
import { MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA, MatLegacyDialog, MatLegacyDialogRef as MatDialogRef } from "@angular/material/legacy-dialog";
import { CatalogEditDialogData } from "./item-create-dialog/item-create-dialog.data";
import { CTManagerItemStock } from "../../../_core/classes/ct-manager-item-stock";
import { CatalogCloneItemComponent } from "./catalog-clone-item/catalog-clone-item.component";
import { CatalogCloneItemConfiguration } from "./catalog-clone-item/catalog-clone-item.configuration";
import { CTMGeneralService } from "../../../_core/lib/general.service";
import { CtWebapiGenericResponse } from "@ctsolution/ct-webapi";
import { ChildModuleItemRouteData } from "../../../_core/route-data/child-module-item.route-data";
import { CTConfigurationModel } from "../../../_core/classes/ct-configuration-model";
import { CtManagerService } from "../../../_core/lib/ct-manager.service";
import { CatalogService } from "../catalog.service";

@Component({
  selector: "app-catalog-edit",
  template: `
  <mat-tab-group>
    <mat-tab label="Dati generali">

    <mat-card>

<mat-card-content>

  <mat-card-title>

  </mat-card-title>

  <div class="ct-model-container">

  <ct-model *ngIf="itemModelConfiguration" [configuration]="itemModelConfiguration"></ct-model>

  </div>

  <mat-card-actions *ngIf="itemModelConfiguration?.form && (isModule || isDialogMode)" align="end">

    <ct-button [configuration]="submitButton"></ct-button>

  </mat-card-actions>

</mat-card-content>

</mat-card>
    </mat-tab>
    <mat-tab [label]=" 'supplierManagementLabel' | translate " [disabled]="!pId">

    <ng-container *ngIf="enableSupplierTable">

      <div class="ct-manager-master-detail-container">

        <ct-model *ngIf="suppliersModelConfiguration" [configuration]="suppliersModelConfiguration"></ct-model>

      </div>

    </ng-container>

    </mat-tab>

  </mat-tab-group>

  <!-- Footer dialog: bottone Chiudi visibile solo quando aperto come dialog -->
  <div *ngIf="isDialogMode" mat-dialog-actions style="display:flex; justify-content:space-between; padding-top:8px;">
    <ct-button [configuration]="closeDialogButton"></ct-button>
  </div>

  <ng-template #headerActions>

    <ct-button *ngIf="pId" [configuration]="createButton"></ct-button>

</ng-template>
`
})
export class CatalogEditComponent implements AfterViewInit {

  @ViewChild("headerActions") headerActions: TemplateRef<any> | null = null;

  itemModelRouteData: CtModelRouteData = ItemRouteData()
    .setModelType(CtModelType.FORM);
  itemModelConfiguration: CtModelConfiguration<CTManagerItem> | null = null;

  supplierModelRouteData: CtModelRouteData = ItemSupplierRouteData()
    .setModelType(CtModelType.DATATABLE);
  suppliersModelConfiguration: CtModelConfiguration<CatalogEditComponent> | null = null;

  pId: string | null = null;
  priceModule: any;
  isModule = false;

  submitButton: CtButtonConfiguration = CtButtonConfiguration
    .create()
    .setLabel("CT_PAGE.CT_FORM.save")
    .setClass('ct-model-submit-button')
    .setAction(() => this.onSubmitModule())
    .setMatherialOptions(MAT_RAISED_PRIMARY);

  createButton: CtButtonConfiguration = CtButtonConfiguration
    .create()
    .setLabel("duplicateItem")
    .setIcon("content_copy")
    .setAction(() => this.createModule())
    .setMatherialOptions(MAT_RAISED_PRIMARY);

  /** Bottone Chiudi — visibile solo in modalità dialog */
  closeDialogButton: CtButtonConfiguration = CtButtonConfiguration
    .create()
    .setLabel("close")
    .setAction(() => this.dialogRef?.close(this.dialogData?.lastCreatedStock ?? null))
    .setMatherialOptions(MAT_RAISED_WARN);

  /**
   * Dati iniettati quando il component è aperto come dialog.
   * null quando è usato come route page normale.
   */
  get isDialogMode(): boolean {
    return !!this.dialogData;
  }

  constructor(
    private route: ActivatedRoute,
    private catalogService: CatalogService,
    private onFlyCreateHelper: CtModelOnFlyCreateService,
    private cdr: ChangeDetectorRef,
    private dialog: MatLegacyDialog,
    private modelService: CtModelService<any>,
    private generalService: CTMGeneralService,
    private managerService: CtManagerService,
    private formatConfigService: FormatConfigService,
    private ctdatatableService: CtDatatableContainerService,
    @Optional() @Inject(MAT_DIALOG_DATA) private dialogData: CatalogEditDialogData | null,
    @Optional() private dialogRef: MatDialogRef<CatalogEditComponent> | null
  ) {

    this.setupSaveInterceptor();

    if (this.isDialogMode) {

      // In modalità dialog tutti i parametri sono già disponibili in dialogData:
      // non serve aspettare la route, inizializziamo subito senza timeout.
      // setupSuppliersModelConfiguration e setPriceToReturn vengono saltati:
      // i fornitori si abilitano dopo il primo salvataggio tramite _notifyItemSaved.
      this.setupItemModelConfiguration();

    } else {

      // In modalità route i paramMap sono disponibili solo dopo il primo tick
      this.setPriceToReturn();

      setTimeout(() => {

        this.setupItemModelConfiguration();
        this.setupSuppliersModelConfiguration();

      }, 500);

    }

  }

  /**
   * Configura l'interceptor per il salvataggio dei dati
   * Pulisce i dati prima dell'invio al backend convertendo le virgole in punti
   */
  private setupSaveInterceptor(): void {
    const originalPutInfos = this.modelService.putInfos?.bind(this.modelService);
    if (originalPutInfos) {
      this.modelService.putInfos = (configuration: any, data: any) => {
        const cleanData = this.cleanDataForSave(data);
        return originalPutInfos(configuration, cleanData);
      };
    }
  }

  /**
   * Pulisce i dati prima del salvataggio convertendo i numeri con virgola in formato con punto
   * Questo garantisce compatibilità con il backend che si aspetta il punto decimale
   * @param data - Dati del form da pulire
   * @returns Dati puliti con formato numerico corretto
   */
  private cleanDataForSave(data: any): any {
    if (!data) return data;

    const cleaned = { ...data };

    // Campi numerici che, se svuotati dall'utente, devono essere inviati come 0
    // (non "" né null): altrimenti il backend va in errore di parsing.
    const zeroOnEmptyFields = ['DefaultPrice', 'DefaultMinimumQty'];

    // Converti virgole in punti per TUTTI i campi numerici
    Object.keys(cleaned).forEach(key => {
      const value = cleaned[key];

      // Prezzo / Quantità minima svuotati: il form emette "" (o null), ma il backend
      // richiede 0. Forziamo 0 solo su questi campi.
      if (
        zeroOnEmptyFields.includes(key) &&
        (value === null || value === undefined || (typeof value === 'string' && value.trim() === ''))
      ) {
        cleaned[key] = 0;
        return;
      }

      if (value !== null && value !== undefined && value !== '') {
        const stringValue = value.toString();

        // Se contiene virgola e sembra un numero (formato: 123,45)
        if (stringValue.includes(',') && /^\d+,\d+$/.test(stringValue)) {
          const numericValue = parseFloat(stringValue.replace(',', '.'));
          if (!isNaN(numericValue)) {
            cleaned[key] = numericValue;
          }
        }
      }
    });

    return cleaned;
  }

  /**
   * Determina se mostrare la tabella dei fornitori
   * Visibile solo per Item (non Module) e solo in modalità modifica (non creazione)
   */
  get enableSupplierTable(): boolean {

    if (!this.itemModelConfiguration) return false;

    const typeFilter = this.itemModelConfiguration.filterValues.constants?.find(flt => flt.Field === 'Type');

    return !!this.itemModelConfiguration.RouteData?.id && typeFilter?.Value === ItemType.Item;

  }

  /**
   * Configura il modello per il form principale dell'articolo/modulo
   * Gestisce le differenze tra Item e Module
   */
  async setupItemModelConfiguration() {

    // In modalità dialog leggiamo i parametri da dialogData, non dalla route
    this.pId = this.isDialogMode
      ? null
      : this.route.snapshot.paramMap.get("id");

    if (this.pId) {
      this.itemModelRouteData.setId(+this.pId);
    }

    const configuration = CtModelConfiguration
      .create<CTManagerItem>()
      .setRouteData(this.itemModelRouteData)


    const typePathValue: string | null = this.isDialogMode
      ? this.dialogData!.typePathValue
      : this.route.snapshot.paramMap.get("type");

    if (!typePathValue) return;

    const constantType: ItemType | null = this.catalogService.getCatalogTypeByRouteValue(typePathValue);

    if (constantType) {

      configuration
        .filterValues
        .addConstantFilter(
          CTModelDatatableFilter
            .create()
            .setField('Type')
            .setValue(constantType)
            .setOperatorType(CtBinaryOperator.Equal)
        );

      const isModuleTemplate: boolean = constantType === ItemType.Module;

      const fieldsCustomTemplates: any = [
        { prop: "Type", disabled: true, required: true, visible: false },
        { prop: "Suppliers", visible: false }, // useremo la tabella esterna per i fornitori
        { prop: "Category", visible: !isModuleTemplate },
        { prop: "Brand", visible: !isModuleTemplate },
        // FIX: Corretto typo "ThousanPrice" → "ThousandPrice"
        { prop: "ThousandPrice", visible: !isModuleTemplate },
        {
          prop: "DefaultUnitOfMeasure",
          disabled: !!configuration.RouteData?.id // per un articolo non devo piu poter modificare l'unità di misura una volta settato
        }
      ];

      if (isModuleTemplate) {

        this.isModule = true;

        // In modalità dialog non tocchiamo route.data (non esiste il contesto router)
        if (!this.isDialogMode) {
          this
            .route
            .data
            .subscribe(data => {
              data["title"] = "Assemblati";
            });
        }

        if (this.pId) {

          const value =
          {
            prop: "DefaultPrice",
            hint: MateriaHintExtensionConfig
              .create()
              .setMessage(`Clicca qui per applicare prezzo consigliato: ${this.priceModule ?? ""}`)
              .setAction((control: CtControlConfiguration | null) => this.getPriceForModule(control))
          }

          fieldsCustomTemplates.push(value);
        }

        configuration
          .setDefaultActionsEnabled(false)

      }

      configuration
        .setFieldsCustomTemplates(fieldsCustomTemplates);

    }

    // In modalità dialog disabilitiamo le default actions del ct-model:
    // il salvataggio è gestito dal nostro bottone custom (onSubmitModule)
    // che non naviga via router e mantiene la dialog aperta.
    if (this.isDialogMode) {
      configuration.setDefaultActionsEnabled(false);
    }

    this.itemModelConfiguration = configuration;

  }

  /**
   * Gestisce il salvataggio per i moduli e per gli Item in modalità dialog.
   * Converte il DefaultUnitOfMeasure nel formato corretto per il backend.
   */
  onSubmitModule() {

    this.itemModelConfiguration
      ?.form
      ?.markAllAsTouched();

    if (this.itemModelConfiguration?.form?.valid) {

      // Prendiamo solo i campi effettivamente valorizzati: rimuoviamo null/undefined
      // per evitare di sovrascrivere campi esistenti sul backend con valori vuoti.
      // I campi hidden (es. Type, Suppliers) hanno value null e non devono essere inviati.
      const rawValue = this.itemModelConfiguration.form.value;
      const value = Object.keys(rawValue).reduce((acc: any, key: string) => {
        if (rawValue[key] !== null && rawValue[key] !== undefined) {
          acc[key] = rawValue[key];
        }
        return acc;
      }, {});

      if (value['DefaultUnitOfMeasure']) {
        value['DefaultUnitOfMeasure'] = { Oid: value['DefaultUnitOfMeasure'] };
      }

      this.modelService
        .putInfos(this.itemModelConfiguration, value)
        ?.subscribe((res: CtWebapiGenericResponse<any>) => {

          const id = this.pId ? +this.pId : res.Result;

          if (this.isDialogMode) {

            // In modalità dialog: non navighiamo, notifichiamo il chiamante
            this._notifyItemSaved(id, value);

          } else {

            this.generalService.navigateOnCTModelRouter(["catalog", "module"], "detail", {
              value: { Oid: id, Name: this.itemModelConfiguration?.form?.get("Name")?.value ?? "assemblato" },
              configuration: this.itemModelConfiguration,
              qpKeys: ["Name"]
            });

          }

        });

    }

  }

  /**
   * Notifica il chiamante (dialog) che l'articolo è stato salvato con successo.
   * Aggiorna pId e routeData per eventuali salvataggi successivi nella stessa sessione.
   * Invoca il callback onItemSaved passando il CTManagerItemStock costruito dall'articolo.
   * @param id  - Oid dell'articolo (dal Result della response o da pId già esistente)
   * @param formValue - Valore corrente del form
   */
  private _notifyItemSaved(id: number, formValue: any): void {

    // Aggiorna pId e routeData: consente modifiche successive senza riaprire la dialog
    if (!this.pId) {
      this.pId = String(id);
      this.itemModelRouteData.setId(id);

      // Abilita la tab Fornitori ora che abbiamo l'Oid
      this.setupSuppliersModelConfiguration();
    }

    if (this.dialogData) {

      const item = CTManagerItem.create({
        Oid:  id,
        Name: formValue.Name  ?? null,
        Code: formValue.Code  ?? null,
        DefaultUnitOfMeasure: formValue.DefaultUnitOfMeasure ?? null
      } as CTManagerItem);

      const stock: CTManagerItemStock = CTManagerItemStock.createByCTManagerItem(item);

      // Memorizza sempre l'ultimo stock creato: viene restituito alla chiusura
      // della dialog tramite dialogRef.close() per permettere al chiamante
      // di filtrare/selezionare l'articolo nella datatable.
      this.dialogData.lastCreatedStock = stock;

      if (this.dialogData.onItemSaved) {
        this.dialogData.onItemSaved(stock);
      }

    }

  }

  /**
   * Configura il modello per la tabella dei fornitori
   * Filtra i fornitori per l'articolo corrente
   */
  setupSuppliersModelConfiguration() {

    const configuration = CtModelConfiguration
      .create<CatalogEditComponent>()
      .setRouteData(this.supplierModelRouteData)
      .setFilterable(false)
      .setFieldsCustomTemplates([{ prop: "Item", disabled: false }])
      .setOnCreate(() => this.openItemSupplierForm())
      .setOnEdit((itemSupplier: ItemSupplier) => this.openItemSupplierForm(itemSupplier.Oid));

    configuration
      .filterValues
      .addConstantFilter(CTModelDatatableFilter
        .create()
        .setField('Item.Oid')
        .setValue(this.itemModelConfiguration?.RouteData?.id)
        .setOperatorType(CtBinaryOperator.Equal));

    this.suppliersModelConfiguration = configuration;


  }

  /**
   * Apre il form modale per creare/modificare un fornitore
   * Gestisce la sincronizzazione tra ThousandPrice e DefaultBuyPrice
   * @param Oid - ID del fornitore da modificare (null per creazione nuovo)
   */
  openItemSupplierForm(Oid: number | null = null) {

    const routeData: CtModelRouteData = CtModelRouteData
      .create()
      .setController(ItemSupplierRouteData().controller)
      .setModelType(CtModelType.FORM);

    const configuration: CtModelConfiguration<any> | null = CtModelConfiguration.create()

    if (Oid) {

      routeData
        .setId(Oid);

    }

    // In modalità route DataSource contiene l'oggetto già caricato dall'API.
    // In modalità dialog (creazione articolo) DataSource è null: usiamo pId come fallback
    // per pre-valorizzare il campo Item nel form del fornitore.
    const itemValue = this.itemModelConfiguration?.DataSource ?? (this.pId ? { Oid: +this.pId } : null);

    if (itemValue) {

      configuration
        .filterValues
        .addConstantFilter(
          CTModelDatatableFilter
            .create()
            .setField('Item')
            .setValue(itemValue)
            .setOperatorType(CtBinaryOperator.Equal)
        );

    }

    configuration
      .setRouteData(routeData)
      .setFieldsCustomTemplates([{ prop: 'Item', disabled: true }])

    this.onFlyCreateHelper
      .openOnFlyCreate(configuration)
      .afterClosed()
      .subscribe((reload: any) => {

        if (!reload) return;

        if (this.isDialogMode) {

          // In modalità dialog il bus globale di CtDatatableContainerService
          // non raggiunge la datatable annidiata nel dialog: forziamo la rigenerazione
          // della configurazione, che fa sì che Angular ricrei il ct-model con i dati freschi.
          this.suppliersModelConfiguration = null;
          setTimeout(() => this.setupSuppliersModelConfiguration());

        } else {

          // In modalità route usiamo il refresh tramite bus globale (comportamento originale)
          this.ctdatatableService.refreshData(ItemSupplierRouteData().controller);

        }

      });

    // Setup sincronizzazione ThousandPrice ↔ DefaultBuyPrice per form fornitori
    setTimeout(() => {
      const digits = this.formatConfigService.defaultPriceDigits;
      const multiplier = Math.pow(10, digits);

      if (configuration.form?.controls['ThousandPrice']) {

        // FIX: Corretto calcolo iniziale - MOLTIPLICARE per 1000, non dividere
        // DefaultBuyPrice → ThousandPrice (es: 8 → 8000)
        configuration.form?.controls['ThousandPrice'].setValue(
          Math.round((configuration.form?.controls['DefaultBuyPrice'].value * 1000) * multiplier) / multiplier,
          { emitEvent: false }
        );

        // Quando cambia ThousandPrice, ricalcola DefaultBuyPrice
        // ThousandPrice → DefaultBuyPrice (es: 8000 → 8). Se vuoto → 0.
        configuration.form?.controls['ThousandPrice']?.valueChanges.subscribe((value: any) => {

          if (value) {
            const cleanValue = value.toString().replace(',', '.');

            configuration.form?.patchValue({
              DefaultBuyPrice: Math.round((cleanValue / 1000) * multiplier) / multiplier
            }, { emitEvent: false });

          } else {

            configuration.form?.patchValue({
              DefaultBuyPrice: 0
            }, { emitEvent: false });

          }

        });

        // Quando cambia DefaultBuyPrice, ricalcola ThousandPrice
        // DefaultBuyPrice → ThousandPrice (es: 8 → 8000). Se vuoto → 0.
        configuration.form?.controls['DefaultBuyPrice']?.valueChanges.subscribe((value: any) => {

          if (value) {
            const cleanValue = value.toString().replace(',', '.');
            configuration.form?.patchValue({
              ThousandPrice: Math.round((cleanValue * 1000) * multiplier) / multiplier
            }, { emitEvent: false });

          } else {

            // Prezzo svuotato: il backend richiede 0 (non "" né null).
            configuration.form?.patchValue({
              DefaultBuyPrice: 0,
              ThousandPrice: 0
            }, { emitEvent: false });

          }

        });

      }

      // Prezzo d'acquisto e Quantità minima svuotati nel popup → 0 (non "" né null),
      // altrimenti il backend va in errore di parsing. Il popup usa un CtModelService
      // diverso (dialog su injector root) e non passa dall'interceptor cleanDataForSave,
      // quindi normalizziamo qui i controlli del form.
      const zeroOnEmptyFields = ['DefaultBuyPrice', 'DefaultMinimumQty'];
      const isEmptyValue = (v: any) =>
        v === null || v === undefined || (typeof v === 'string' && v.trim() === '');

      zeroOnEmptyFields.forEach(field => {
        const control = configuration.form?.controls[field];
        if (!control) return;

        // Valore iniziale vuoto (record caricato) → 0
        if (isEmptyValue(control.value)) {
          control.setValue(0, { emitEvent: false });
        }

        // Campo svuotato dall'utente → 0
        control.valueChanges.subscribe((value: any) => {
          if (isEmptyValue(value)) {
            control.setValue(0, { emitEvent: false });
          }
        });
      });

    }, 1000);

  }

  async ngAfterViewInit(): Promise<void> {

    // Carica la configurazione dei formati (decimali per prezzi e numeri)
    const formatConfiguration: CTConfigurationModel = CTConfigurationModel.create();

    await this.managerService.getComponentOverride("formatDigits", "formatConfiguration", formatConfiguration).then((component: any) => {
      return;
    });

    this.formatConfigService.setDefaultPriceDigits(formatConfiguration.formatPrice);
    this.formatConfigService.setDefaultNumberDigits(formatConfiguration.formatNumber);
    const digits = this.formatConfigService.defaultPriceDigits;
    const multiplier = Math.pow(10, digits);


    const typePathValue: string | null = this.route.snapshot.paramMap.get("type");
    const constantType: ItemType | null = this.catalogService.getCatalogTypeByRouteValue(typePathValue);

    // Setup header actions solo per Item e solo in modalità route (non dialog)
    if (constantType == ItemType.Item && !this.isDialogMode) {
      this.route
        .queryParams
        .subscribe(qp => {

          this.route
            .data
            .subscribe(data => {

              data['headerActions'] = this.headerActions;
              data['urls'] = [{ title: '' }];
              this.cdr.detectChanges();

            })

        });
    }

    // Setup sincronizzazione ThousandPrice ↔ DefaultPrice per form principale
    setTimeout(() => {

      if (this.itemModelConfiguration?.form?.controls['ThousandPrice']) {

        // FIX: Corretto calcolo iniziale - MOLTIPLICARE per 1000, non dividere
        // DefaultPrice → ThousandPrice (es: 8 → 8000)
        this.itemModelConfiguration?.form?.controls['ThousandPrice'].setValue(
          Math.round((this.itemModelConfiguration?.form?.controls['DefaultPrice'].value * 1000) * multiplier) / multiplier,
          { emitEvent: false }
        );

        // Quando cambia ThousandPrice, ricalcola DefaultPrice
        // ThousandPrice → DefaultPrice (es: 8000 → 8)
        this.itemModelConfiguration?.form?.controls['ThousandPrice']?.valueChanges.subscribe((value: any) => {

          if (value) {
            // Converti virgola in punto SOLO per i calcoli interni, NON per l'UI
            const cleanValue = value.toString().replace(',', '.');
            const result = Math.round((cleanValue / 1000) * multiplier) / multiplier;

            this.itemModelConfiguration?.form?.patchValue({
              DefaultPrice: result
            }, { emitEvent: false });

          } else {
            this.itemModelConfiguration?.form?.patchValue({
              DefaultPrice: null
            }, { emitEvent: false });
          }

        });

        // Quando cambia DefaultPrice, ricalcola ThousandPrice
        // DefaultPrice → ThousandPrice (es: 8 → 8000)
        this.itemModelConfiguration?.form?.controls['DefaultPrice']?.valueChanges.subscribe((value: any) => {

          if (value) {
            // Converti virgola in punto SOLO per i calcoli interni, NON per l'UI
            const cleanValue = value.toString().replace(',', '.');
            const result = Math.round((cleanValue * 1000) * multiplier) / multiplier;

            this.itemModelConfiguration?.form?.patchValue({
              ThousandPrice: result
            }, { emitEvent: false });

          } else {
            this.itemModelConfiguration?.form?.patchValue({
              ThousandPrice: null
            }, { emitEvent: false });
          }

        });

      }

    }, 1000);

  }

  /**
   * Apre il dialog per clonare un articolo
   */
  createModule() {

    const typePathValue: string | null = this.route.snapshot.paramMap.get("type");
    const formValue = this.itemModelConfiguration?.form?.value;
    let codeValue: string | null = null;
    if (formValue) {

      codeValue = formValue.Code;

    }


    if (!this.pId || !typePathValue || !codeValue) return;

    this.dialog.open(CatalogCloneItemComponent, {
      data: {
        configuration:
          CatalogCloneItemConfiguration.create()
            .setContent("cloneItemLabel")
            .setTitle("warning")
            .setItemOid(+this.pId)
            .setCodeValue(codeValue)
      }, maxWidth: '500px', minWidth: '300px'
    })


  }

  /**
   * Applica il prezzo calcolato al campo DefaultPrice del modulo
   * Il prezzo viene calcolato dalla somma dei componenti del modulo
   * @param control - Controllo del campo DefaultPrice
   */
  getPriceForModule(control: CtControlConfiguration | null) {

    if (!this.pId) return;

    const form = control?.formParent;

    if (!form) return;

    form.patchValue({
      DefaultPrice: this.priceModule
    });

  }

  /**
   * Calcola il prezzo consigliato per i moduli
   * Somma: (Item.DefaultPrice * Qty) per ogni componente del modulo
   */
  private setPriceToReturn() {

    this.pId = this.route.snapshot.paramMap.get("id");

    if (!this.pId) return

    const configuration: CtModelConfiguration<any> = CtModelConfiguration
      .create()
      .setRouteData(ChildModuleItemRouteData());

    const filters = CtModelDatatableOperators
      .create()
      .setFilters([
        CTModelDatatableFilter
          .create()
          .setField('Module.Oid')
          .setValue(this.pId)
          .setOperatorType(CtBinaryOperator.Equal)
      ]);

    this.modelService.getList(configuration, filters).subscribe((response: CtWebapiGenericResponse<any>) => {

      const res = response.Result?.DataSource;
      this.priceModule = 0;

      if (res) {

        res.forEach((elm: { Item: { DefaultPrice: number; }; Qty: number; }) => {

          if (elm.Item) {
            this.priceModule = this.priceModule + elm.Item.DefaultPrice * elm.Qty;
          }

        });

      }

    })

  }

}
